export default __webpack_public_path__ + "static/media/js.16de3b93.svg";